import { Form, Checkbox as AntDCheckbox } from 'antd'

import { useField } from 'formik'
import PropTypes from 'prop-types'


const { Item } = Form

export default function Checkbox({
  containerClassName = undefined,
  label = '',
  layout = undefined,
  ...rest
}) {
  const [field, meta] = useField({ ...rest, type: 'checkbox' })
  const hasError = Boolean(meta.touched && meta.error)

  return (
    <Item
      className={containerClassName}
      hasFeedback={false}
      validateStatus={hasError ? 'error' : ''}
      help={hasError && meta.error}
      layout={layout}
    >
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <AntDCheckbox {...field} {...rest} value={field?.value || ''}>
        {label}
      </AntDCheckbox>
    </Item>
  )
}

Checkbox.propTypes = {
  containerClassName: PropTypes.string,
  label: PropTypes.string,
  layout: PropTypes.string,
}
